import { request, requestPage } from '@/lib/apiClient';
import { endpoints } from '@/features/endpoints';
import type { ModerationItem, ModerationType, ReviewStatus } from '@/types/domain';
import type { Page } from '@/types/api';

export function fetchModerationQueue(
  params: { type?: string; status?: string; limit?: number; cursor?: string },
  signal?: AbortSignal,
): Promise<Page<ModerationItem>> {
  return requestPage<ModerationItem>(endpoints.moderation.list, {
    query: {
      type: params.type,
      status: params.status,
      limit: params.limit ?? 40,
      cursor: params.cursor,
    },
    ...(signal ? { signal } : {}),
  });
}

export type ModerationDecision = {
  decision: Extract<ReviewStatus, 'approved' | 'rejected'>;
  reason?: string;
};

export function decideModerationItem(
  id: string,
  decision: ModerationDecision,
): Promise<ModerationItem> {
  return request<ModerationItem>(endpoints.moderation.decide(id), {
    method: 'PATCH',
    body: decision,
  });
}

export const MODERATION_TYPE_LABELS: Record<ModerationType, string> = {
  certificate: 'Certificate',
  transformation: 'Transformation',
  media: 'Media',
  trainer: 'Coach profile',
};
